"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.subStateMatchHelper = exports.pendingStateMatchHelper = exports.hasProvider = exports.convertAppointment = exports.canceledStateMatchHelper = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _xstate = require("./constants/xstate");
/**
 * Function that determines whether or not a provider exists and returns a boolean
 *
 * @param {} provider
 * @return boolean
 */
const hasProvider = provider => (0, _keys.default)(provider).length !== 0;

/**
 * Function to take a backend appointment and strip it down to only the
 * necessary portions for the machine's context
 *
 * @param responseData The appointment response data in backend format. It contains the appointment and capabilities objects.
 * @returns An object containing appointmentId, appointment, location, and providerId,
 *          to be inserted into the machines context
 */
exports.hasProvider = hasProvider;
const convertAppointment = responseData => {
  if (!responseData) {
    return {};
  }
  const {
    appointment: originalAppointment = {
      location: {
        address: {}
      },
      provider: {}
    },
    capabilities = {
      cancel: {
        enabled: true
      }
    }
  } = responseData;
  const {
    id: appointmentId = '',
    location: {
      location_pma_id: locationId = 0
    },
    patient_relationship: patientRelationship = '',
    provider: {
      provider_pma_id: providerId = 0
    },
    purpose_name: patientPurpose = '',
    start_datetime: startDateTime = '',
    latest_cancellation: latestCancellation = '',
    status = ''
  } = originalAppointment;
  const {
    cancel: {
      enabled: isCancelEnabled
    }
  } = capabilities;
  return {
    appointmentId,
    appointment: {
      patientPurpose,
      patientRelationship,
      status,
      startDateTime,
      latestCancellation,
      isCancelEnabled
    },
    locationId,
    providerId
  };
};

/**
 * Helper function to determine when the state machine is in one of the states reflecting a canceled appointment
 * (`confirmationPage` or `canceledPreviously`)
 *
 * @param state xstate state object
 * @returns boolean Whether the state machine is in a canceled appointment context
 */
exports.convertAppointment = convertAppointment;
const canceledStateMatchHelper = state => {
  return state && (state.matches(_xstate.states.confirmationPage) || state.matches(_xstate.states.canceledPreviously));
};

/**
 * Helper function to determine when the state machine is in one of the loading states
 * (`appointment` or `provider`) but not in an error state
 *
 * @param state xstate state object
 * @returns boolean Whether the state machine is in a pending context
 */
exports.canceledStateMatchHelper = canceledStateMatchHelper;
const pendingStateMatchHelper = state => {
  return state && (state.matches(_xstate.states.appointment) || state.matches(_xstate.states.provider)) && !subStateMatchHelper(_xstate.states.error, state);
};

/**
 * Helper function to determine when the state machine is in a given substate
 *
 * @param subState xstate substate (e.g. "@state/CANCEL_DISABLED_PAGE")
 * @param state the entire xstate state object
 * @returns boolean Whether the state machine is in a given substate
 */
exports.pendingStateMatchHelper = pendingStateMatchHelper;
const subStateMatchHelper = (subState, state) => {
  var _context;
  return state && (0, _includes.default)(_context = (0, _values.default)(state.value)).call(_context, subState);
};
exports.subStateMatchHelper = subStateMatchHelper;